import React, { memo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { InfoFooter } from "@swiggy-private/dls-web-recipe-common-web/dist/components/InfoFooter";
import { PAYMENT_FAILURE_CONSTANTS, IMAGES } from "./constant";
import { Container, Header, PaymentAmountText } from "./styled";
import { IPaymentFailureContentProps } from "./types";

const PaymentFailureContent = memo(
    ({ amount, onTryOtherMethods, paymentFailureCardData }: IPaymentFailureContentProps) => {
        return (
            <Container>
                {!isEmpty(amount) && (
                    <Header>
                        <PaymentAmountText variant="V2.body3.neutral.regular">
                            {PAYMENT_FAILURE_CONSTANTS.PAYMENT_OF} {amount}
                        </PaymentAmountText>
                    </Header>
                )}
                <InfoFooter
                    iconId={paymentFailureCardData?.paymentIcon || IMAGES.PAYMENT_FAILURE}
                    iconSize={PAYMENT_FAILURE_CONSTANTS.ICON_HEIGHT * 2}
                    iconDisplayWidth={String(PAYMENT_FAILURE_CONSTANTS.ICON_WIDTH)}
                    iconDisplayHeight={String(PAYMENT_FAILURE_CONSTANTS.ICON_HEIGHT)}
                    iconAlt={PAYMENT_FAILURE_CONSTANTS.IMAGE_ALT}
                    header={{
                        text: {
                            info: paymentFailureCardData?.title || PAYMENT_FAILURE_CONSTANTS.TITLE,
                            font: "V2.heading2.neutral.black",
                            color: "text_Highest_Emphasis",
                        },
                    }}
                    description={{
                        text: {
                            info:
                                paymentFailureCardData?.description ||
                                PAYMENT_FAILURE_CONSTANTS.DESCRIPTION,
                            font: "V2.body2.neutral.regular",
                            color: "text_Med_Emphasis",
                        },
                    }}
                    cta={{
                        text:
                            paymentFailureCardData?.buttonText ||
                            PAYMENT_FAILURE_CONSTANTS.BUTTON_TEXT,
                        onClick: onTryOtherMethods,
                    }}
                />
            </Container>
        );
    }
);

PaymentFailureContent.displayName = "PaymentFailureContent";

export default PaymentFailureContent;
